"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilter = void 0;
var react_1 = __importDefault(require("react"));
// TODO: Should probably use PopupFilter
var _LEFT = 0;
var DateFilter = /** @class */ (function (_super) {
    __extends(DateFilter, _super);
    function DateFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleOption = _this.toggleOption.bind(_this);
        _this.optionSelected = _this.optionSelected.bind(_this);
        return _this;
    }
    DateFilter.prototype.render = function () {
        var _this = this;
        var _a = this.props, year = _a.year, _b = _a.left, left = _b === void 0 ? 0 : _b;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "underline cursor-pointer select-none", onClick: function () { return _this.props.onFilterOpen(!_this.props.open); } }, this.props.title),
            this.props.open && (react_1.default.createElement("div", { className: "z-30 absolute bg-white shadow flex flex-col py-1", style: { top: 20, left: left, minWidth: 100, minHeight: 100 } },
                react_1.default.createElement("div", { className: "relative font-bold flex" },
                    react_1.default.createElement("div", { onClick: function () { return _this.props.onYearChange(_this.props.year - 1); }, className: "w-1/3 px-4 py-2 text-center cursor-pointer flex-grow\n                hover:bg-grey-lighter" }, "\u00AB"),
                    react_1.default.createElement("div", { className: "w-1/3 px-4 py-2 text-center cursor-pointer flex-grow" }, year),
                    react_1.default.createElement("div", { onClick: function () { return _this.props.onYearChange(_this.props.year + 1); }, className: "w-1/3 px-4 py-2 text-center cursor-pointer flex-grow\n                hover:bg-grey-lighter" }, "\u00BB")),
                react_1.default.createElement("div", { className: "relative font-bold flex" },
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-01")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-01")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Jan"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-02")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-02")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Feb"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-03")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-03")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Mar")),
                react_1.default.createElement("div", { className: "relative font-bold flex" },
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-04")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-04")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Apr"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-05")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-05")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "May"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-06")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-06")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Jun")),
                react_1.default.createElement("div", { className: "relative font-bold flex" },
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-07")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-07")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Jul"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-08")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-08")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Aug"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-09")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-09")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Sep")),
                react_1.default.createElement("div", { className: "relative font-bold flex" },
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-10")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-10")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Oct"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-11")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-11")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Nov"),
                    react_1.default.createElement("div", { onClick: function () { return _this.toggleOption("".concat(year, "-12")); }, className: "w-1/3 m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n".concat(this.optionSelected("".concat(year, "-12")) ? "bg-teal-light" : "hover:bg-grey-lighter") }, "Dec"))))));
    };
    DateFilter.prototype.mapMonth = function (monthNumber) {
        switch (monthNumber) {
            case "01":
                return "Jan";
            case "02":
                return "Feb";
            case "03":
                return "Mar";
            case "04":
                return "Apr";
            case "05":
                return "May";
            case "06":
                return "Jun";
            case "07":
                return "Jul";
            case "08":
                return "Aug";
            case "09":
                return "Sep";
            case "10":
                return "Oct";
            case "11":
                return "Nov";
            case "12":
                return "Dec";
        }
        throw Error("Invalid month ".concat(monthNumber));
    };
    DateFilter.prototype.toggleOption = function (optionKey) {
        var _a = optionKey.split("-"), year = _a[0], month = _a[1];
        var monthName = this.mapMonth(month);
        var option = this.props.options.find(function (o) { return o.key === optionKey; });
        if (!option) {
            this.props.options.push({
                key: optionKey,
                value: "".concat(monthName, ", ").concat(year),
                selected: true,
            });
        }
        else {
            option.selected = !option.selected;
        }
        this.props.onFilterChange(this.props.options);
    };
    DateFilter.prototype.optionSelected = function (optionKey) {
        var option = this.props.options.find(function (o) { return o.key === optionKey; });
        return option && option.selected;
    };
    DateFilter.Props = {
        left: _LEFT,
    };
    return DateFilter;
}(react_1.default.Component));
exports.DateFilter = DateFilter;
